const Loading = (props) => {
    return (
        <div id="full-page-loader" className="loader-block d-none">
            <div className="loader"></div>
        </div>
    );
};

export default Loading;
